"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query SearchResultsPage(\n    $query: String!\n    $limit: Int!\n    $skip: Int\n    $orderBy: PlpOrderBy = Recommended\n    $facetFiltering: [PlpRowsFacetFilterInput!]\n    $withRelatedLinks: Boolean = false\n  ) {\n    application {\n      productSearchPage {\n        products(query: $query, topRows: $limit, skipRows: $skip, orderBy: $orderBy, facetFiltering: $facetFiltering) {\n          ...SearchResultsProducts\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchResultsPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _searchResultsProducts = require("./fragments/searchResultsProducts");
const searchResultsPageQuery = exports.searchResultsPageQuery = (0, _fetching.gql)(_templateObject(), _searchResultsProducts.searchResultsProducts);
